export default __webpack_public_path__ + "images/5N.02da413.png";